export default {
  data() {
    return {
      movingCell: null,
      endingCell: null,
      startingCell: null
    }
  },
  methods: {
    mouseMove(cell) {
      this.movingCell = cell;
    },
    mouseDown(cell) {
      this.movingCell = cell;
      this.endingCell = null;
      this.startingCell = cell;
    },
    mouseUp(cell) {
      if (!this.startingCell) {
        this.endingCell = null;
        this.movingCell = null;
        this.startingCell = null;

        return false;
      }

      this.endingCell = cell;

      if (this.endingCell.column < this.startingCell.column) {
        let startCell = this.endingCell;
        this.endingCell = this.startingCell;
        this.movingCell = null;
        this.startingCell = startCell;
      }

      if (typeof this.mouseUpCallback === 'function') {
        this.mouseUpCallback(this.startingCell, this.endingCell);
      }

      this.endingCell = null;
      this.movingCell = null;
      this.startingCell = null;
    },
    isMarked(cell) {
      if (!cell || !this.startingCell || !this.movingCell) {
        return false;
      }
      if (cell.row_id !== this.startingCell.row_id) {
        return false;
      }

      if (this.movingCell.column >= this.startingCell.column) {
        return cell.column <= this.movingCell.column && cell.column >= this.startingCell.column;
      }

      return cell.column >= this.movingCell.column && cell.column <= this.startingCell.column;
    }
  },
}
